"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DsGridClasses = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
var _busbud = _interopRequireDefault(require("../themes/busbud"));
var _utilities = require("../utilities");
var _responsiveProps = require("../utilities/responsiveProps");
var _Grid = require("./Grid.types");
const _excluded = ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justifyContent", "spacing", "xSpacing", "ySpacing", "wrap", "zeroMinWidth", "xs", "sm", "md", "lg", "xl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const directions = ['row', 'row-reverse', 'column', 'column-reverse'];
const justifyContent = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
const DsGridClasses = exports.DsGridClasses = {
  item: 'DsGrid__Item'
};
const margin = [0.25, 0.5, 1, 2, 3, 6, 8, 10];
function generateGridCssDefinition() {
  const styles = {};
  _Grid.sizes.forEach(size => {
    switch (size) {
      case true:
        {
          styles[size.toString()] = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
          };
          break;
        }
      case 'auto':
        {
          styles[size.toString()] = {
            flexBasis: 'auto',
            flexGrow: 0,
            maxWidth: 'none'
          };
          break;
        }
      default:
        {
          // Keep 7 significant numbers.
          const width = `${Math.round(size / 24 * 10e7) / 10e5}%`;
          styles[size] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
          };
        }
    }
  });
  return styles;
}
function generateGutterXCssDefinition(theme, classes) {
  const styles = {};
  margin.forEach(spacing => {
    if (typeof spacing !== 'number') {
      return;
    }
    const themeSpacing = theme.busbud.space.base * spacing;
    const offset = getOffset(themeSpacing, 2);
    styles[spacing] = {
      marginLeft: `-${offset}`,
      marginRight: `-${offset}`,
      width: `calc(100% + ${getOffset(themeSpacing)})`,
      [`& > .${classes.item}`]: {
        paddingLeft: offset,
        paddingRight: offset
      }
    };
  });
  return styles;
}
function generateGutterYCssDefinition(theme, classes) {
  const styles = {};
  margin.forEach(spacing => {
    if (typeof spacing !== 'number') {
      return;
    }
    const themeSpacing = theme.busbud.space.base * spacing;
    const offset = getOffset(themeSpacing, 2);
    styles[spacing] = {
      marginTop: `-${offset}`,
      marginBottom: `-${offset}`,
      [`& > .${classes.item}`]: {
        paddingTop: offset,
        paddingBottom: offset
      }
    };
  });
  return styles;
}
function generateDirectionCssDefinition() {
  const styles = {};
  directions.forEach(direction => {
    styles[(0, _utilities.pascalCase)(direction)] = {
      flexDirection: direction
    };
  });
  return styles;
}
function generateJustifyContentCssDefinition() {
  const styles = {};
  justifyContent.forEach(alignment => {
    styles[(0, _utilities.pascalCase)(alignment)] = {
      justifyContent: alignment
    };
  });
  return styles;
}
function getOffset(val) {
  let div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return `${val / div}px`;
}
const gridCssDefinition = generateGridCssDefinition();
const directionCssDefinition = generateDirectionCssDefinition();
const justifyContentCssDefinition = generateJustifyContentCssDefinition();
const gutterXCssDefinition = generateGutterXCssDefinition(_busbud.default, {
  item: DsGridClasses.item
});
const gutterYCssDefinition = generateGutterYCssDefinition(_busbud.default, {
  item: DsGridClasses.item
});
const responsiveStyles = (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(_busbud.default, {
  grid: gridCssDefinition,
  xSpacing: gutterXCssDefinition,
  ySpacing: gutterYCssDefinition,
  direction: directionCssDefinition,
  justifyContent: justifyContentCssDefinition
});
const useStyles = (0, _createStyles.createStyles)(_objectSpread({
  /* Styles applied to the root element */
  root: {},
  /* Styles applied to the root element if `container={true}`. */
  container: {
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%'
  },
  /* Styles applied to the root element if `item={true}`. */
  itemBase: {
    boxSizing: 'border-box',
    margin: '0' // For instance, it's useful when used with a `figure` element.
  },
  /* Styles applied to the root element if `zeroMinWidth={true}`. */
  zeroMinWidth: {
    minWidth: 0
  },
  /* Styles applied to the root element if `wrap="nowrap"`. */
  wrapNowrap: {
    flexWrap: 'nowrap'
  },
  /* Styles applied to the root element if `wrap="reverse"`. */
  wrapReverse: {
    flexWrap: 'wrap-reverse'
  },
  /* Styles applied to the root element if `alignItems="center"`. */
  alignItemsCenter: {
    alignItems: 'center'
  },
  /* Styles applied to the root element if `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    alignItems: 'flex-start'
  },
  /* Styles applied to the root element if `alignItems="flex-end"`. */
  alignItemsFlexEnd: {
    alignItems: 'flex-end'
  },
  /* Styles applied to the root element if `alignItems="baseline"`. */
  alignItemsBaseline: {
    alignItems: 'baseline'
  },
  /* Styles applied to the root element if `alignContent="center"`. */
  alignContentCenter: {
    alignContent: 'center'
  },
  /* Styles applied to the root element if `alignContent="flex-start"`. */
  alignContentFlexStart: {
    alignContent: 'flex-start'
  },
  /* Styles applied to the root element if `alignContent="flex-end"`. */
  alignContentFlexEnd: {
    alignContent: 'flex-end'
  },
  /* Styles applied to the root element if `alignContent="space-between"`. */
  alignContentSpaceBetween: {
    alignContent: 'space-between'
  },
  /* Styles applied to the root element if `alignContent="space-around"`. */
  alignContentSpaceAround: {
    alignContent: 'space-around'
  }
}, responsiveStyles));
function getAlignContentClassKey(str) {
  return `alignContent${(0, _utilities.pascalCase)(str)}`;
}
function getAlignItemsClassKey(str) {
  return `alignItems${(0, _utilities.pascalCase)(str)}`;
}
function getWrapClassKey(str) {
  return `wrap${(0, _utilities.pascalCase)(str)}`;
}
function getSizeClassKey(breakpoint, value) {
  return (0, _responsiveProps.getResponsiveClassName)('grid', String(value), breakpoint);
}
function getSpacingClasses(spacingProp, spacingPrefix, classes) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(spacingProp, spacingPrefix).map(className => classes[className]);
}

/**
 * **❗️ DEPRECATED**: Use Tailwind utility classes instead.
 *
 * The grid creates visual consistency between layouts while allowing flexibility across a wide variety of designs. Busbud Design’s responsive UI is based on a 24-column grid layout.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-layout-grid--page)
 *
 * @deprecated
 */
const Grid = /*#__PURE__*/_react.default.forwardRef(function Grid(props, ref) {
  const {
      alignContent = 'stretch',
      alignItems = 'stretch',
      classes: classesOverrides,
      className,
      component: Component = 'div',
      container = false,
      direction = 'row',
      item = false,
      justifyContent = 'flex-start',
      spacing = 'none',
      xSpacing = 'none',
      ySpacing = 'none',
      wrap = 'wrap',
      zeroMinWidth = false,
      xs = false,
      sm = false,
      md = false,
      lg = false,
      xl = false
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes
  } = useStyles({
    classesOverrides
  });
  let spacingClasses = [];
  if (spacing !== 'none') {
    spacingClasses = [...getSpacingClasses(spacing, 'xSpacing', classes), ...getSpacingClasses(spacing, 'ySpacing', classes)];
  } else {
    if (xSpacing !== 'none') {
      spacingClasses = [...spacingClasses, ...getSpacingClasses(xSpacing, 'xSpacing', classes)];
    }
    if (ySpacing !== 'none') {
      spacingClasses = [...spacingClasses, ...getSpacingClasses(ySpacing, 'ySpacing', classes)];
    }
  }
  const directionClasses = (0, _responsiveProps.getResponsiveClassNamesForProp)(direction, 'direction').map(className => classes[className]);
  const justifyContentClasses = (0, _responsiveProps.getResponsiveClassNamesForProp)(justifyContent, 'justifyContent').map(className => classes[className]);
  return /*#__PURE__*/_react.default.createElement(Component
  // @ts-ignore TS2590
  // clsx is used here instead of cx because of style conflicts caused by responsive styles
  , (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, {
      [classes.container]: container,
      [classes.itemBase]: item,
      [DsGridClasses.item]: item,
      [classes.zeroMinWidth]: zeroMinWidth,
      [classes[getAlignContentClassKey(alignContent)]]: alignContent !== 'stretch',
      [classes[getAlignItemsClassKey(alignItems)]]: alignItems !== 'stretch',
      [classes[getWrapClassKey(wrap)]]: wrap !== 'wrap',
      [classes[getSizeClassKey('xs', xs)]]: xs !== false,
      [classes[getSizeClassKey('sm', sm)]]: sm !== false,
      [classes[getSizeClassKey('md', md)]]: md !== false,
      [classes[getSizeClassKey('lg', lg)]]: lg !== false,
      [classes[getSizeClassKey('xl', xl)]]: xl !== false
    }, ...spacingClasses, ...directionClasses, ...justifyContentClasses, className),
    ref: ref
  }, other));
});
var _default = exports.default = Grid;